import merge from 'deepmerge';
import { SecurityOutline } from '../components/Icon';
import jdTheme, { CustomTheme } from '.';

const theme: CustomTheme = {
    config: {
        displayName: "AktieSport",
        headerLogo: '/Logo-Akiesport-Navigation.png',
        headerHeight: '64px',
        headerLogoSize: {height: '30px'},
        headerShowLogo: true,
        headerBackgroundColor: 'white',

        fontSrc: 'https://fonts.googleapis.com/css2?family=Electrolize&display=swap',

        icons: {
            securityIcon: SecurityOutline,
        },
        titleFontWeight: 'bold',
        stepFontWeight: 'bold',
    },

    global: {
        font: {
            family: '"Electrolize", sans-serif',
        },
    },

    button: {
        border: {
            radius: '0px'
        },
        extend: 'height: 48px; font-weight: bold',
    },

    radioButton: {
        font: {
            weight: 'bold',
        }
    },

};

const aktieSportTheme: CustomTheme = merge(jdTheme, theme);

export default aktieSportTheme;
